import environmental from 'common/assets/svg/common/earth-solid.svg';
import SvgRender from 'common/components/general/SvgRender';

const EmptyState = ({ table }) => {
  return (
    <div className="w-100p d-flex align-items-center justify-content-center position-relative">
      <div className="mt-20 me-20 pe-20">
        <SvgRender
          src={environmental}
          className="cme-12 text-light-gray-2"
          style={{ width: 330, height: 330 }}
        />
        <div className="text-secondary-gray fs-18 position-absolute ms-20 top-50 mt-6">
          You have not selected any country or area yet.
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
